
export default {

  SET_PROJECT_VESSELS: (state, payload) => {
    let pvIds = [];
    (payload || []).forEach(pv => pvIds.push(pv.Id || pv.id));
    state.selProjectVesselIds = pvIds;
  },

  SET_SEL_PROJECT_ID: (state, payload) => state.selProjectId = payload ,
  SET_SEL_VESSEL_ID: (state, payload) => state.selVesselId = payload,

}